// Settings types for the app settings system

export interface AppSetting {
  id: string;
  setting_key: string;
  setting_value: any;
  description?: string;
  category?: string;
  data_type: 'string' | 'number' | 'boolean' | 'array' | 'object';
  is_active: boolean;
  is_public: boolean;
  created_at: string;
  updated_at: string;
}

export interface SettingResponse {
  key: string;
  value: any;
  description?: string;
  category?: string;
  data_type: string;
  updated_at: string;
}

export interface SettingsApiResponse {
  success: boolean;
  settings?: Record<string, {
    value: any;
    description?: string;
    category?: string;
    data_type: string;
    updated_at: string;
  }>;
  setting?: SettingResponse;
  error?: string;
}

export interface SettingsCache {
  data: Record<string, any>;
  timestamp: number;
  duration: number;
}

// Default values for fallback
export const DEFAULT_SETTINGS = {
  daily_reading_limit: 1,
  additional_reading_limit: 2,
  max_total_daily_readings: 3,
  admin_users: [457246],
  super_admin_users: [457246],
  debug_mode: false,
  streak_enabled: true,
  reset_button_enabled: true,
  maintenance_mode: false,
  nft_required_for_additional: false,
  streak_reset_hour: 0,
  app_title: 'STRADAMUS',
  app_subtitle: 'Tarot readings on Farcaster',
  max_question_length: 120,
  cache_settings_duration: 300,
  max_api_requests_per_minute: 60,
} as const;

export type SettingKey = keyof typeof DEFAULT_SETTINGS;

// Setting categories
export enum SettingCategory {
  LIMITS = 'limits',
  ADMIN = 'admin',
  FEATURES = 'features',
  UI = 'ui',
  PERFORMANCE = 'performance',
}

// Admin permission levels
export interface AdminPermissions {
  isAdmin: boolean;
  isSuperAdmin: boolean;
  canUpdateSettings: boolean;
  canAccessDebugMode: boolean;
}